import { render, staticRenderFns } from "./page_brand.vue?vue&type=template&id=6db0b968&scoped=true"
import script from "./page_brand.vue?vue&type=script&lang=js"
export * from "./page_brand.vue?vue&type=script&lang=js"
import style0 from "./page_brand.vue?vue&type=style&index=0&id=6db0b968&prod&lang=less"
import style1 from "./page_brand.vue?vue&type=style&index=1&id=6db0b968&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db0b968",
  null
  
)

export default component.exports